module.exports = __webpack_public_path__ + "static/media/plantSix.edbde5df.jpg";